import React from 'react';
import {compose} from 'recompose';

import withMobile, {WithMobileProps} from 'hoc/withMobile';
import withTablet, {WithTabletProps} from 'hoc/withTablet';

interface FullProps extends WithMobileProps, WithTabletProps {}

export function withDesktopOnly<T extends FullProps>(WrappedComponent: React.ComponentType<T>) {
    class WithDesktopOnly extends React.Component<T> {
        static displayName = `withDesktopOnly(${
            WrappedComponent.displayName || WrappedComponent.name || 'Component'
        })`;

        render() {
            const {isMobile, isTablet, ...rest} = this.props;
            return Boolean(!isMobile && !isTablet) && <WrappedComponent {...(rest as T)} />;
        }
    }

    return compose<T, FullProps>(withMobile, withTablet)(WithDesktopOnly);
}
